// extracted by mini-css-extract-plugin
export default {"big-image":"avatar_big-image__cZrEV","small-image":"avatar_small-image__IGdM-"};